import React from "react";
import MarcaService from "../../services/MarcaService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaMarca extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: MarcaService,
            labels: {
                title: 'Lista de Marca(s)',
                btnNewRegister: 'Marca',
            },
            keyItem: 'idMarca',
            urlForm: '/CadMarca',
            itensFilter: ["idMarca", "nome" , "categorias"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-1 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-3"> Nome </th>
                <th className="col-md-7"> Categorias </th>
                <th className="col-md-1 text-center"> Utilização </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idMarca}</td>
                <td>{item.nome}</td>
                <td>{item.categorias}</td>
                <td className="text-center">{item.nrUtilizacao}</td>
            </>);
    }

    render() {
        return super.render();
    }
}